import React from "react";
import { BrowserRouter, Switch } from "react-router-dom";
import "./scss/style.scss";
import { PrivateRoute, PublicRoute } from "./reusable";

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);
const TheLayout = React.lazy(() => import("./containers/TheLayout"));
const Login = React.lazy(() => import("./views/pages/login/Login"));
const Application = React.lazy(() =>
  import("./views/pages/applicant/components/UserForm")
);
const Tracker = React.lazy(() => import("./views/pages/progressChart/Tracker"));
const ApplicationCode = React.lazy(() =>
  import("./views/pages/progressChart/ApplicationCode")
);
const ForgetPassword = React.lazy(() =>
  import("./views/pages/login/forgetForm")
);

const App = () => {
  return (
    <BrowserRouter>
      <React.Suspense fallback={loading}>
        <Switch>
          <PublicRoute
            exact
            path="/login"
            name="Login Page"
            component={Login}
          />
          <PublicRoute
            exact
            path="/application"
            name="Application Page"
            component={Application}
          />
          <PublicRoute
            exact
            path="/application-code"
            name="Application Code"
            component={ApplicationCode}
          />
          <PublicRoute
            exact
            path="/app-tracker"
            name="Tracker"
            component={Tracker}
          />

          <PublicRoute
            exact
            path="/reset-password"
            name="Forget Password"
            component={ForgetPassword}
          />

          {true ? <PrivateRoute path="/" name="H" component={TheLayout} /> : ""}
        </Switch>
      </React.Suspense>
    </BrowserRouter>
  );
};

export default App;
